export const MOMENT_LOCALE = {
  'EN': 'en',
  'CN': 'zh-cn',
}





// WEBPACK FOOTER //
// ./src/constants/index.js